import { useIntl } from 'react-intl';
import { PreviewDrawer } from '../../ui/PreviewDrawer';
import { EnumAndFormulaCellValue } from '../columns/types';
import { FormulaPreview } from './components/FormulaPreview';

type LookupDrawerProps = {
  onClose: () => void;
  lookupForDrawer: {
    matching: Record<string, unknown>;
    value: EnumAndFormulaCellValue;
  } | null;
};

export const LookupDrawer = ({
  onClose,
  lookupForDrawer,
}: LookupDrawerProps) => {
  const intl = useIntl();

  return (
    <PreviewDrawer
      onClose={onClose}
      open={!!lookupForDrawer}
      title={lookupForDrawer?.value.label ?? ''}
      subtitle={intl.formatMessage(
        {
          id: 'features.fieldManager.fieldDetail.enumFormulaEditing.lookupDrawer.subtitle',
        },
        { count: lookupForDrawer?.value.count }
      )}
      content={
        <FormulaPreview
          value={JSON.stringify(lookupForDrawer?.matching ?? {}, null, 2)}
        />
      }
    />
  );
};
